export const SITE = {
  // Header
  navLogo: "site-nav-logo",
  navAbout: "site-nav-about",
  navServices: "site-nav-services",
  navProcess: "site-nav-process",
  navTestimonials: "site-nav-testimonials",
  navFaq: "site-nav-faq",
  navCallBtn: "site-nav-call-btn",
  navWhatsappBtn: "site-nav-whatsapp-btn",
  navCallbackBtn: "site-nav-callback-btn",

  // Hero
  heroCallBtn: "hero-call-btn",
  heroWhatsappBtn: "hero-whatsapp-btn",
  heroCallbackBtn: "hero-callback-btn",

  // Services & content
  servicesGrid: "services-grid",
  serviceCard: (key) => `service-card-${key}`,
  processStep: (n) => `process-step-${n}`,
  testimonialCard: (id) => `testimonial-card-${id}`,
  faqItem: (n) => `faq-item-${n}`,

  // Sticky / footer
  stickyCallBtn: "sticky-call-btn",
  stickyWhatsappBtn: "sticky-whatsapp-btn",
  footerCallBtn: "footer-call-btn",
  footerWhatsappBtn: "footer-whatsapp-btn",
  footerCallbackBtn: "footer-callback-btn",

  // Pricing / consultation
  pricingSection: "pricing-section",
  pricingCard: (key) => `pricing-card-${key}`,
  pricingBookBtn: (key) => `pricing-book-${key}`,
  paymentUpiId: "payment-upi-id",
  paymentUpiCopy: "payment-upi-copy",
  paymentUpiPhone: "payment-upi-phone",
  paymentQrPlaceholder: "payment-qr-placeholder",

  // Health packages
  packagesSection: "packages-section",
  packageCard: (key) => `package-card-${key}`,
  packagesCallBtn: "packages-call-btn",
  packagesWhatsappBtn: "packages-whatsapp-btn",

  // Callback dialog
  callbackDialog: "callback-dialog",
  callbackName: "callback-input-name",
  callbackPhone: "callback-input-phone",
  callbackConcern: "callback-input-concern",
  callbackMessage: "callback-input-message",
  callbackSubmit: "callback-submit-btn",
  callbackSuccess: "callback-success",
};
